"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "acquarica-del-capo": {
    "4aa0d69c": [{
      "hkey": "5e287bc1",
      "slug": "presicce-acquarica",
      "name": "Presicce-Acquarica",
      "primary": true,
      "skipSearch": false
    }],
    "acquarica-del-capo": [{
      "hkey": "5e287bc1",
      "slug": "presicce-acquarica",
      "name": "Presicce-Acquarica",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "alice-superiore": {
    "7bfac220": [{
      "hkey": "7c8415c0",
      "slug": "gauna",
      "name": "Gauna",
      "primary": true,
      "skipSearch": false
    }],
    "alice-superiore": [{
      "hkey": "1bdaec02",
      "slug": "val-di-chy",
      "name": "Val di Chy",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9e8ab7e": [{
      "hkey": "1bdaec02",
      "slug": "val-di-chy",
      "name": "Val di Chy",
      "primary": true,
      "skipSearch": false
    }]
  },
  "auditore": {
    "16034ba7": [{
      "hkey": "b5d556bc",
      "slug": "castelnuovo-san-giovanni",
      "name": "Castelnuovo San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "311bd420": [{
      "hkey": "aefd9c0d",
      "slug": "casinina",
      "name": "Casinina",
      "primary": true,
      "skipSearch": false
    }],
    "49319da3": [{
      "hkey": "ab443ee0",
      "slug": "san-leo-nuovo",
      "name": "San Leo Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "56757cae": [{
      "hkey": "85d573f0",
      "slug": "sassocorvaro-auditore",
      "name": "Sassocorvaro Auditore",
      "primary": true,
      "skipSearch": false
    }],
    "83b61884": [{
      "hkey": "309fd7ac",
      "slug": "ca-angelino",
      "name": "Ca' Angelino",
      "primary": true,
      "skipSearch": false
    }],
    "auditore": [{
      "hkey": "85d573f0",
      "slug": "sassocorvaro-auditore",
      "name": "Sassocorvaro Auditore",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "berra": {
    "56939a38": [{
      "hkey": "dcf216ae",
      "slug": "riva-del-po",
      "name": "Riva del Po",
      "primary": true,
      "skipSearch": false
    }],
    "84482bbd": [{
      "hkey": "02cc8171",
      "slug": "cologna",
      "name": "Cologna",
      "primary": true,
      "skipSearch": false
    }],
    "berra": [{
      "hkey": "dcf216ae",
      "slug": "riva-del-po",
      "name": "Riva del Po",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9fc898a": [{
      "hkey": "d4b483b7",
      "slug": "serravalle",
      "name": "Serravalle",
      "primary": true,
      "skipSearch": false
    }]
  },
  "bibione": {
    "af62285d": [{
      "hkey": "c94f2e04",
      "slug": "bibione",
      "name": "San Michele al Tagliamento",
      "primary": true,
      "skipSearch": false
    }],
    "bibione": [{
      "hkey": "c94f2e04",
      "slug": "bibione",
      "name": "San Michele al Tagliamento",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 10,
      "slugLevelParent": "san-michele-al-tagliamento"
    }]
  },
  "bigarello": {
    "2552d0f5": [{
      "hkey": "601b493b",
      "slug": "stradella",
      "name": "Stradella",
      "primary": true,
      "skipSearch": false
    }],
    "68b7ee2f": [{
      "hkey": "47d40aa7",
      "slug": "bigarello",
      "name": "Bigarello",
      "primary": true,
      "skipSearch": false
    }],
    "d2ab00a7": [{
      "hkey": "220e205e",
      "slug": "gazzo",
      "name": "Gazzo",
      "primary": true,
      "skipSearch": false
    }],
    "df10f749": [{
      "hkey": "a431381e",
      "slug": "bazza",
      "name": "Bazza",
      "primary": true,
      "skipSearch": false
    }],
    "f4adba9c": [{
      "hkey": "636837c0",
      "slug": "san-giorgio-bigarello",
      "name": "San Giorgio Bigarello",
      "primary": true,
      "skipSearch": false
    }]
  },
  "borgofranco-sul-po": {
    "7a936f0e": [{
      "hkey": "b296dc0c",
      "slug": "borgocarbonara",
      "name": "Borgocarbonara",
      "primary": true,
      "skipSearch": false
    }],
    "borgofranco-sul-po": [{
      "hkey": "b296dc0c",
      "slug": "borgocarbonara",
      "name": "Borgocarbonara",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "brez": {
    "2a0eb5d5": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "skipSearch": false
    }],
    "93a64f6d": [{
      "hkey": "432a4371",
      "slug": "carnalez",
      "name": "Carnalez",
      "primary": true,
      "skipSearch": false
    }],
    "brez": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef565d8c": [{
      "hkey": "81a030ca",
      "slug": "rivo",
      "name": "Rivo",
      "primary": true,
      "skipSearch": false
    }],
    "efb26317": [{
      "hkey": "555305cc",
      "slug": "traversara",
      "name": "Traversara",
      "primary": true,
      "skipSearch": false
    }],
    "f0a800d1": [{
      "hkey": "cc1bb6f0",
      "slug": "salobbi",
      "name": "Salobbi",
      "primary": true,
      "skipSearch": false
    }],
    "f0bb0979": [{
      "hkey": "0bf63e74",
      "slug": "arsio",
      "name": "Arsio",
      "primary": true,
      "skipSearch": false
    }]
  },
  "ca-d-andrea": {
    "28cc4e74": [{
      "hkey": "0f1ef908",
      "slug": "casanova-d-offredi",
      "name": "Casanova d'Offredi",
      "primary": true,
      "skipSearch": false
    }],
    "3ce89647": [{
      "hkey": "e6ce1910",
      "slug": "brolpasino",
      "name": "Brolpasino",
      "primary": true,
      "skipSearch": false
    }],
    "50c81095": [{
      "hkey": "43e23ac9",
      "slug": "ronca-de-golferami",
      "name": "Ronca de Golferami",
      "primary": true,
      "skipSearch": false
    }],
    "6be795a5": [{
      "hkey": "e47f70f5",
      "slug": "breda-guazzoni",
      "name": "Breda Guazzoni",
      "primary": true,
      "skipSearch": false
    }],
    "b6f5d548": [{
      "hkey": "73b86783",
      "slug": "torre-de-picenardi",
      "name": "Torre de' Picenardi",
      "primary": true,
      "skipSearch": false
    }],
    "ca-d-andrea": [{
      "hkey": "73b86783",
      "slug": "torre-de-picenardi",
      "name": "Torre de' Picenardi",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0e07eb2": [{
      "hkey": "914b3ea8",
      "slug": "pieve-san-maurizio",
      "name": "Pieve San Maurizio",
      "primary": true,
      "skipSearch": false
    }],
    "e6b80b4e": [{
      "hkey": "c89a40aa",
      "slug": "fossa-guazzona",
      "name": "Fossa Guazzona",
      "primary": true,
      "skipSearch": false
    }]
  },
  "cagno": {
    "39bc54e1": [{
      "hkey": "2ccb73ac",
      "slug": "solbiate-con-cagno",
      "name": "Solbiate con Cagno",
      "primary": true,
      "skipSearch": false
    }],
    "7b69ecf4": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "skipSearch": false
    }],
    "9427e8bb": [{
      "hkey": "4f2bfca1",
      "slug": "frari",
      "name": "Frari",
      "primary": true,
      "skipSearch": false
    }],
    "cagno": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "camo": {
    "203aec94": [{
      "hkey": "12506668",
      "slug": "santo-stefano-belbo",
      "name": "Santo Stefano Belbo",
      "primary": true,
      "skipSearch": false
    }],
    "camo": [{
      "hkey": "12506668",
      "slug": "santo-stefano-belbo",
      "name": "Santo Stefano Belbo",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "campolongo-sul-brenta": {
    "0b2c7c5f": [{
      "hkey": "905eab83",
      "slug": "valbrenta",
      "name": "Valbrenta",
      "primary": true,
      "skipSearch": false
    }],
    "campolongo-sul-brenta": [{
      "hkey": "905eab83",
      "slug": "valbrenta",
      "name": "Valbrenta",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "canevino": {
    "46161c5c": [{
      "hkey": "d708186a",
      "slug": "colli-verdi",
      "name": "Colli Verdi",
      "primary": true,
      "skipSearch": false
    }],
    "b53a965a": [{
      "hkey": "5bface1b",
      "slug": "caseo",
      "name": "Caseo",
      "primary": true,
      "skipSearch": false
    }],
    "canevino": [{
      "hkey": "d708186a",
      "slug": "colli-verdi",
      "name": "Colli Verdi",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "carano": {
    "2a7d144a": [{
      "hkey": "e77fa9d1",
      "slug": "cela",
      "name": "Cela",
      "primary": true,
      "skipSearch": false
    }],
    "79bfe998": [{
      "hkey": "97a00876",
      "slug": "solaiolo",
      "name": "Solaiolo",
      "primary": true,
      "skipSearch": false
    }],
    "979a41f9": [{
      "hkey": "cfa882db",
      "slug": "calvello",
      "name": "Calvello",
      "primary": true,
      "skipSearch": false
    }],
    "ac32bee4": [{
      "hkey": "f82fa49a",
      "slug": "aguai",
      "name": "Aguai",
      "primary": true,
      "skipSearch": false
    }],
    "b418653a": [{
      "hkey": "1958633d",
      "slug": "ville-di-fiemme",
      "name": "Ville di Fiemme",
      "primary": true,
      "skipSearch": false
    }],
    "carano": [{
      "hkey": "1958633d",
      "slug": "ville-di-fiemme",
      "name": "Ville di Fiemme",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb151169": [{
      "hkey": "9020ede4",
      "slug": "veronza",
      "name": "Veronza",
      "primary": true,
      "skipSearch": false
    }]
  },
  "carbonara-di-po": {
    "b06c0ffa": [{
      "hkey": "b296dc0c",
      "slug": "borgocarbonara",
      "name": "Borgocarbonara",
      "primary": true,
      "skipSearch": false
    }],
    "carbonara-di-po": [{
      "hkey": "b296dc0c",
      "slug": "borgocarbonara",
      "name": "Borgocarbonara",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "castelfondo": {
    "4d1afd9a": [{
      "hkey": "37ccd439",
      "slug": "cologna",
      "name": "Cologna",
      "primary": true,
      "skipSearch": false
    }],
    "5757dcf1": [{
      "hkey": "0b88a422",
      "slug": "la-villa",
      "name": "La Villa",
      "primary": true,
      "skipSearch": false
    }],
    "9dd70800": [{
      "hkey": "294c4533",
      "slug": "plaz",
      "name": "Plaz",
      "primary": true,
      "skipSearch": false
    }],
    "castelfondo": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ed4b1d1b": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "skipSearch": false
    }]
  },
  "castellania": {
    "065d9c20": [{
      "hkey": "f33f899c",
      "slug": "buffalora",
      "name": "Buffalora",
      "primary": true,
      "skipSearch": false
    }],
    "5883343a": [{
      "hkey": "485fd245",
      "slug": "san-andrea",
      "name": "San Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "5c608758": [{
      "hkey": "9f9fe118",
      "slug": "valsorda",
      "name": "Valsorda",
      "primary": true,
      "skipSearch": false
    }],
    "79d66872": [{
      "hkey": "d71ea46f",
      "slug": "san-alosio",
      "name": "San Alosio",
      "primary": true,
      "skipSearch": false
    }],
    "9943ef70": [{
      "hkey": "7e232d00",
      "slug": "mulino",
      "name": "Mulino",
      "primary": true,
      "skipSearch": false
    }],
    "a4a5bc5a": [{
      "hkey": "0b532636",
      "slug": "mossabella",
      "name": "Mossabella",
      "primary": true,
      "skipSearch": false
    }],
    "castellania": [{
      "hkey": "5eab7487",
      "slug": "castellania-coppi",
      "name": "Castellania Coppi",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3807dc0": [{
      "hkey": "c1609893",
      "slug": "buia",
      "name": "Buia",
      "primary": true,
      "skipSearch": false
    }],
    "fb6e7416": [{
      "hkey": "5eab7487",
      "slug": "castellania-coppi",
      "name": "Castellania Coppi",
      "primary": true,
      "skipSearch": false
    }]
  },
  "castellar": {
    "43c48bb6": [{
      "hkey": "905bcd24",
      "slug": "regione-pairunella",
      "name": "Regione Pairunella",
      "primary": true,
      "skipSearch": false
    }],
    "6dc17604": [{
      "hkey": "4ebf9199",
      "slug": "regione-san-guglielmo",
      "name": "Regione San Guglielmo",
      "primary": true,
      "skipSearch": false
    }],
    "b1d5be18": [{
      "hkey": "cfa9bc37",
      "slug": "saluzzo",
      "name": "Saluzzo",
      "primary": true,
      "skipSearch": false
    }],
    "c0beeaea": [{
      "hkey": "67521233",
      "slug": "regione-testa-nera",
      "name": "Regione Testa Nera",
      "primary": true,
      "skipSearch": false
    }],
    "castellar": [{
      "hkey": "cfa9bc37",
      "slug": "saluzzo",
      "name": "Saluzzo",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7af0b05": [{
      "hkey": "523c8586",
      "slug": "regione-giardino",
      "name": "Regione Giardino",
      "primary": true,
      "skipSearch": false
    }],
    "eb551636": [{
      "hkey": "9ad5a477",
      "slug": "regione-morra",
      "name": "Regione Morra",
      "primary": true,
      "skipSearch": false
    }]
  },
  "cavaglio-spoccia": {
    "cavaglio-spoccia": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec71f25c": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "skipSearch": false
    }]
  },
  "cerreto-castello": {
    "a17f5eb6": [{
      "hkey": "34f1d7d1",
      "slug": "quaregna-cerreto",
      "name": "Quaregna Cerreto",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto-castello": [{
      "hkey": "34f1d7d1",
      "slug": "quaregna-cerreto",
      "name": "Quaregna Cerreto",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "cismon-del-grappa": {
    "cismon-del-grappa": [{
      "hkey": "905eab83",
      "slug": "valbrenta",
      "name": "Valbrenta",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d777fa69": [{
      "hkey": "53a05c5b",
      "slug": "fastro",
      "name": "Fastro",
      "primary": true,
      "skipSearch": false
    }],
    "ded5ad08": [{
      "hkey": "905eab83",
      "slug": "valbrenta",
      "name": "Valbrenta",
      "primary": true,
      "skipSearch": false
    }],
    "fc91102d": [{
      "hkey": "f87fc707",
      "slug": "primolano",
      "name": "Primolano",
      "primary": true,
      "skipSearch": false
    }]
  },
  "cloz": {
    "5eebe1fb": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "skipSearch": false
    }],
    "cloz": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "conco": {
    "2b5518a8": [{
      "hkey": "e20928f3",
      "slug": "gomarolo",
      "name": "Gomarolo",
      "primary": true,
      "skipSearch": false
    }],
    "810f08be": [{
      "hkey": "c3acfc08",
      "slug": "tortima",
      "name": "Tortima",
      "primary": true,
      "skipSearch": false
    }],
    "8131ad68": [{
      "hkey": "98523e69",
      "slug": "lusiana-conco",
      "name": "Lusiana Conco",
      "primary": true,
      "skipSearch": false
    }],
    "90fc3489": [{
      "hkey": "ad4f0cae",
      "slug": "rubbio",
      "name": "Rubbio",
      "primary": true,
      "skipSearch": false
    }],
    "ceac5543": [{
      "hkey": "b71913a3",
      "slug": "fontanelle",
      "name": "Fontanelle",
      "primary": true,
      "skipSearch": false
    }],
    "conco": [{
      "hkey": "98523e69",
      "slug": "lusiana-conco",
      "name": "Lusiana Conco",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6b32a8d": [{
      "hkey": "4ef36150",
      "slug": "santa-caterina",
      "name": "Santa Caterina",
      "primary": true,
      "skipSearch": false
    }]
  },
  "corigliano-calabro": {
    "corigliano-calabro": [{
      "hkey": "80e583a5",
      "slug": "corigliano-rossano",
      "name": "Corigliano-Rossano",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dba1fa4a": [{
      "hkey": "80e583a5",
      "slug": "corigliano-rossano",
      "name": "Corigliano-Rossano",
      "primary": true,
      "skipSearch": false
    }]
  },
  "crespano-del-grappa": {
    "9f360a48": [{
      "hkey": "f31e5f9a",
      "slug": "pieve-del-grappa",
      "name": "Pieve del Grappa",
      "primary": true,
      "skipSearch": false
    }],
    "crespano-del-grappa": [{
      "hkey": "f31e5f9a",
      "slug": "pieve-del-grappa",
      "name": "Pieve del Grappa",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "cuccaro-monferrato": {
    "91443749": [{
      "hkey": "5e925786",
      "slug": "lu-e-cuccaro-monferrato",
      "name": "Lu e Cuccaro Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "cuccaro-monferrato": [{
      "hkey": "5e925786",
      "slug": "lu-e-cuccaro-monferrato",
      "name": "Lu e Cuccaro Monferrato",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "cursolo-orasso": {
    "5a6a2f98": [{
      "hkey": "5ce51140",
      "slug": "airetta",
      "name": "Airetta",
      "primary": true,
      "skipSearch": false
    }],
    "8e12ac2d": [{
      "hkey": "cbe7f869",
      "slug": "orasso",
      "name": "Orasso",
      "primary": true,
      "skipSearch": false
    }],
    "b235bdfa": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "skipSearch": false
    }],
    "cursolo-orasso": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d97e2aa1": [{
      "hkey": "c9355b14",
      "slug": "cursolo",
      "name": "Cursolo",
      "primary": true,
      "skipSearch": false
    }]
  },
  "daiano": {
    "daiano": [{
      "hkey": "1958633d",
      "slug": "ville-di-fiemme",
      "name": "Ville di Fiemme",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f1795ea1": [{
      "hkey": "1958633d",
      "slug": "ville-di-fiemme",
      "name": "Ville di Fiemme",
      "primary": true,
      "skipSearch": false
    }]
  },
  "drizzona": {
    "040b0735": [{
      "hkey": "6f584a4d",
      "slug": "piadena-drizzona",
      "name": "Piadena Drizzona",
      "primary": true,
      "skipSearch": false
    }],
    "478b2eef": [{
      "hkey": "8121bdda",
      "slug": "castelfranco-d-oglio",
      "name": "Castelfranco d'Oglio",
      "primary": true,
      "skipSearch": false
    }],
    "drizzona": [{
      "hkey": "6f584a4d",
      "slug": "piadena-drizzona",
      "name": "Piadena Drizzona",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eebb8805": [{
      "hkey": "c8d856a5",
      "slug": "pontirolo-capredoni",
      "name": "Pontirolo Capredoni",
      "primary": true,
      "skipSearch": false
    }]
  },
  "faedo": {
    "0317304e": [{
      "hkey": "e6d5ea90",
      "slug": "masetto",
      "name": "Masetto",
      "primary": true,
      "skipSearch": false
    }],
    "4bd02eee": [{
      "hkey": "54212ac5",
      "slug": "canazzi",
      "name": "Canazzi",
      "primary": true,
      "skipSearch": false
    }],
    "822944e9": [{
      "hkey": "4bb5cb0a",
      "slug": "villa-piccola",
      "name": "Villa Piccola",
      "primary": true,
      "skipSearch": false
    }],
    "8b7fbd85": [{
      "hkey": "dcdf05c3",
      "slug": "molini",
      "name": "Molini",
      "primary": true,
      "skipSearch": false
    }],
    "94382731": [{
      "hkey": "59162a50",
      "slug": "san-michele-all-adige",
      "name": "San Michele all'Adige",
      "primary": true,
      "skipSearch": false
    }],
    "ab4ff4cc": [{
      "hkey": "6ddd9774",
      "slug": "barco",
      "name": "Barco",
      "primary": true,
      "skipSearch": false
    }],
    "b88fb8a0": [{
      "hkey": "def445e6",
      "slug": "pineta",
      "name": "Pineta",
      "primary": true,
      "skipSearch": false
    }],
    "f9b40088": [{
      "hkey": "c97da31c",
      "slug": "cadino",
      "name": "Cadino",
      "primary": true,
      "skipSearch": false
    }],
    "faedo": [{
      "hkey": "59162a50",
      "slug": "san-michele-all-adige",
      "name": "San Michele all'Adige",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "falmenta": {
    "20909502": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "skipSearch": false
    }],
    "falmenta": [{
      "hkey": "03b2d260",
      "slug": "valle-cannobina",
      "name": "Valle Cannobina",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "fondo": {
    "a214985e": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "cc2c3f16": [{
      "hkey": "2402814d",
      "slug": "tret",
      "name": "Tret",
      "primary": true,
      "skipSearch": false
    }],
    "e43e8c60": [{
      "hkey": "b1e730d8",
      "slug": "plaze",
      "name": "Plaze",
      "primary": true,
      "skipSearch": false
    }],
    "f7272131": [{
      "hkey": "2f1002a5",
      "slug": "vasio",
      "name": "Vasio",
      "primary": true,
      "skipSearch": false
    }],
    "fondo": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "formignana": {
    "61ff34c8": [{
      "hkey": "962e7bba",
      "slug": "brazzolo",
      "name": "Brazzolo",
      "primary": true,
      "skipSearch": false
    }],
    "f21be062": [{
      "hkey": "53dfad57",
      "slug": "tresignana",
      "name": "Tresignana",
      "primary": true,
      "skipSearch": false
    }],
    "formignana": [{
      "hkey": "53dfad57",
      "slug": "tresignana",
      "name": "Tresignana",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "gattico": {
    "a0e912a6": [{
      "hkey": "4065b7b3",
      "slug": "gattico-veruno",
      "name": "Gattico-Veruno",
      "primary": true,
      "skipSearch": false
    }],
    "gattico": [{
      "hkey": "4065b7b3",
      "slug": "gattico-veruno",
      "name": "Gattico-Veruno",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "lentiai": {
    "054c99e2": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "skipSearch": false
    }],
    "0eee852d": [{
      "hkey": "e6e3e219",
      "slug": "boschi",
      "name": "Boschi",
      "primary": true,
      "skipSearch": false
    }],
    "1cb676d7": [{
      "hkey": "22358201",
      "slug": "stabie",
      "name": "Stabie",
      "primary": true,
      "skipSearch": false
    }],
    "3124efbe": [{
      "hkey": "687279ba",
      "slug": "ronchena",
      "name": "Ronchena",
      "primary": true,
      "skipSearch": false
    }],
    "51b3ce01": [{
      "hkey": "52b6e17b",
      "slug": "canai",
      "name": "Canai",
      "primary": true,
      "skipSearch": false
    }],
    "6721fdb8": [{
      "hkey": "05f3903c",
      "slug": "villapiana",
      "name": "Villapiana",
      "primary": true,
      "skipSearch": false
    }],
    "8a839570": [{
      "hkey": "8a6c22fc",
      "slug": "cesana",
      "name": "Cesana",
      "primary": true,
      "skipSearch": false
    }],
    "c4c6d4be": [{
      "hkey": "3c2831fc",
      "slug": "marziai",
      "name": "Marziai",
      "primary": true,
      "skipSearch": false
    }],
    "ddceaa64": [{
      "hkey": "445bf12d",
      "slug": "colderu",
      "name": "Colderù",
      "primary": true,
      "skipSearch": false
    }],
    "lentiai": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "lu": {
    "2ffbbf52": [{
      "hkey": "66793198",
      "slug": "bodelacchi",
      "name": "Bodelacchi",
      "primary": true,
      "skipSearch": false
    }],
    "48016a7e": [{
      "hkey": "872a7715",
      "slug": "trisoglio",
      "name": "Trisoglio",
      "primary": true,
      "skipSearch": false
    }],
    "492a1aeb": [{
      "hkey": "e87fa755",
      "slug": "borghina",
      "name": "Borghina",
      "primary": true,
      "skipSearch": false
    }],
    "4e12a2a4": [{
      "hkey": "b6b927b3",
      "slug": "martini",
      "name": "Martini",
      "primary": true,
      "skipSearch": false
    }],
    "689ea19d": [{
      "hkey": "5e925786",
      "slug": "lu-e-cuccaro-monferrato",
      "name": "Lu e Cuccaro Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "lu": [{
      "hkey": "5e925786",
      "slug": "lu-e-cuccaro-monferrato",
      "name": "Lu e Cuccaro Monferrato",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "lugnacco": {
    "3eb44ffa": [{
      "hkey": "1bdaec02",
      "slug": "val-di-chy",
      "name": "Val di Chy",
      "primary": true,
      "skipSearch": false
    }],
    "lugnacco": [{
      "hkey": "1bdaec02",
      "slug": "val-di-chy",
      "name": "Val di Chy",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "lusiana": {
    "7c46b5cf": [{
      "hkey": "98523e69",
      "slug": "lusiana-conco",
      "name": "Lusiana Conco",
      "primary": true,
      "skipSearch": false
    }],
    "lusiana": [{
      "hkey": "98523e69",
      "slug": "lusiana-conco",
      "name": "Lusiana Conco",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "malosco": {
    "fb597d5d": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "skipSearch": false
    }],
    "malosco": [{
      "hkey": "ad05bd1a",
      "slug": "borgo-d-anaunia",
      "name": "Borgo d'Anaunia",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "mason-vicentino": {
    "41697895": [{
      "hkey": "23137d10",
      "slug": "colceresa",
      "name": "Colceresa",
      "primary": true,
      "skipSearch": false
    }],
    "c048a05a": [{
      "hkey": "39b81f2d",
      "slug": "villaraspa",
      "name": "Villaraspa",
      "primary": true,
      "skipSearch": false
    }],
    "mason-vicentino": [{
      "hkey": "23137d10",
      "slug": "colceresa",
      "name": "Colceresa",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "mel": {
    "dc5eeb21": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "skipSearch": false
    }],
    "mel": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "meugliano": {
    "f0f714a1": [{
      "hkey": "708f6cbf",
      "slug": "valchiusa",
      "name": "Valchiusa",
      "primary": true,
      "skipSearch": false
    }],
    "meugliano": [{
      "hkey": "708f6cbf",
      "slug": "valchiusa",
      "name": "Valchiusa",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "mezzani": {
    "164dc9af": [{
      "hkey": "1d922528",
      "slug": "sorbolo-mezzani",
      "name": "Sorbolo Mezzani",
      "primary": true,
      "skipSearch": false
    }],
    "3319192d": [{
      "hkey": "fad380da",
      "slug": "mezzano-rondani",
      "name": "Mezzano Rondani",
      "primary": true,
      "skipSearch": false
    }],
    "845b99e1": [{
      "hkey": "30445429",
      "slug": "casale",
      "name": "Casale",
      "primary": true,
      "skipSearch": false
    }],
    "94319c49": [{
      "hkey": "2a20de6c",
      "slug": "mezzano-inferiore",
      "name": "Mezzano Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "b34ea865": [{
      "hkey": "3626feaa",
      "slug": "mezzano-superiore",
      "name": "Mezzano Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "mezzani": [{
      "hkey": "1d922528",
      "slug": "sorbolo-mezzani",
      "name": "Sorbolo Mezzani",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "molvena": {
    "01ee4e22": [{
      "hkey": "f9a2369a",
      "slug": "mure",
      "name": "Mure",
      "primary": true,
      "skipSearch": false
    }],
    "9690feca": [{
      "hkey": "23137d10",
      "slug": "colceresa",
      "name": "Colceresa",
      "primary": true,
      "skipSearch": false
    }],
    "ba3c9045": [{
      "hkey": "95be2a54",
      "slug": "villa",
      "name": "Villa",
      "primary": true,
      "skipSearch": false
    }],
    "molvena": [{
      "hkey": "23137d10",
      "slug": "colceresa",
      "name": "Colceresa",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "mosso": {
    "ad6f1c24": [{
      "hkey": "bbaa8fc1",
      "slug": "valdilana",
      "name": "Valdilana",
      "primary": true,
      "skipSearch": false
    }],
    "mosso": [{
      "hkey": "bbaa8fc1",
      "slug": "valdilana",
      "name": "Valdilana",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "nave-san-rocco": {
    "5dc9f106": [{
      "hkey": "a1afdcea",
      "slug": "terre-d-adige",
      "name": "Terre d'Adige",
      "primary": true,
      "skipSearch": false
    }],
    "nave-san-rocco": [{
      "hkey": "a1afdcea",
      "slug": "terre-d-adige",
      "name": "Terre d'Adige",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "negrar": {
    "2390c90b": [{
      "hkey": "6f7e4f9c",
      "slug": "torbe",
      "name": "Torbe",
      "primary": true,
      "skipSearch": false
    }],
    "441a7078": [{
      "hkey": "65a2a140",
      "slug": "mazzano",
      "name": "Mazzano",
      "primary": true,
      "skipSearch": false
    }],
    "46f3f27c": [{
      "hkey": "bf08372d",
      "slug": "prun",
      "name": "Prun",
      "primary": true,
      "skipSearch": false
    }],
    "4b1686c1": [{
      "hkey": "238f2d3a",
      "slug": "santa-maria",
      "name": "Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "4e9e29f8": [{
      "hkey": "55d4e454",
      "slug": "arbizzano",
      "name": "Arbizzano",
      "primary": true,
      "skipSearch": false
    }],
    "89da825a": [{
      "hkey": "8ff43f15",
      "slug": "negrar-di-valpolicella",
      "name": "Negrar di Valpolicella",
      "primary": true,
      "skipSearch": false
    }],
    "9d9bb171": [{
      "hkey": "0bde3739",
      "slug": "san-peretto",
      "name": "San Peretto",
      "primary": true,
      "skipSearch": false
    }],
    "bd7e3d32": [{
      "hkey": "ac217419",
      "slug": "montecchio",
      "name": "Montecchio",
      "primary": true,
      "skipSearch": false
    }],
    "bea28b9d": [{
      "hkey": "9100ed0f",
      "slug": "san-vito",
      "name": "San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "f361a1f8": [{
      "hkey": "b85962b9",
      "slug": "fane",
      "name": "Fane",
      "primary": true,
      "skipSearch": false
    }],
    "negrar": [{
      "hkey": "8ff43f15",
      "slug": "negrar-di-valpolicella",
      "name": "Negrar di Valpolicella",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "paderno-del-grappa": {
    "636cb8b9": [{
      "hkey": "e4938566",
      "slug": "fietta",
      "name": "Fietta",
      "primary": true,
      "skipSearch": false
    }],
    "d006f710": [{
      "hkey": "f31e5f9a",
      "slug": "pieve-del-grappa",
      "name": "Pieve del Grappa",
      "primary": true,
      "skipSearch": false
    }],
    "paderno-del-grappa": [{
      "hkey": "f31e5f9a",
      "slug": "pieve-del-grappa",
      "name": "Pieve del Grappa",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "pecco": {
    "7d471e3d": [{
      "hkey": "1bdaec02",
      "slug": "val-di-chy",
      "name": "Val di Chy",
      "primary": true,
      "skipSearch": false
    }],
    "pecco": [{
      "hkey": "1bdaec02",
      "slug": "val-di-chy",
      "name": "Val di Chy",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "piadena": {
    "046a9aa9": [{
      "hkey": "64339e5a",
      "slug": "san-paolo-ripa-oglio",
      "name": "San Paolo Ripa Oglio",
      "primary": true,
      "skipSearch": false
    }],
    "9bc50691": [{
      "hkey": "118c9405",
      "slug": "san-lorenzo-guazzone",
      "name": "San Lorenzo Guazzone",
      "primary": true,
      "skipSearch": false
    }],
    "a5bdca4b": [{
      "hkey": "6f584a4d",
      "slug": "piadena-drizzona",
      "name": "Piadena Drizzona",
      "primary": true,
      "skipSearch": false
    }],
    "piadena": [{
      "hkey": "6f584a4d",
      "slug": "piadena-drizzona",
      "name": "Piadena Drizzona",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "presicce": {
    "72e63c53": [{
      "hkey": "5e287bc1",
      "slug": "presicce-acquarica",
      "name": "Presicce-Acquarica",
      "primary": true,
      "skipSearch": false
    }],
    "presicce": [{
      "hkey": "5e287bc1",
      "slug": "presicce-acquarica",
      "name": "Presicce-Acquarica",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "puegnago-sul-garda": {
    "0aa0ec92": [{
      "hkey": "6954a586",
      "slug": "raffa",
      "name": "Raffa",
      "primary": true,
      "skipSearch": false
    }],
    "6ec6e936": [{
      "hkey": "008dbc59",
      "slug": "castello",
      "name": "Castello",
      "primary": true,
      "skipSearch": false
    }],
    "97cedaa6": [{
      "hkey": "8b6f1170",
      "slug": "mura",
      "name": "Mura",
      "primary": true,
      "skipSearch": false
    }],
    "ac6c3121": [{
      "hkey": "4c759029",
      "slug": "palude",
      "name": "Palude",
      "primary": true,
      "skipSearch": false
    }],
    "bd1adc81": [{
      "hkey": "a5d82637",
      "slug": "puegnago-del-garda",
      "name": "Puegnago del Garda",
      "primary": true,
      "skipSearch": false
    }],
    "puegnago-sul-garda": [{
      "hkey": "a5d82637",
      "slug": "puegnago-del-garda",
      "name": "Puegnago del Garda",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "quaregna": {
    "3c2e99af": [{
      "hkey": "34f1d7d1",
      "slug": "quaregna-cerreto",
      "name": "Quaregna Cerreto",
      "primary": true,
      "skipSearch": false
    }],
    "quaregna": [{
      "hkey": "34f1d7d1",
      "slug": "quaregna-cerreto",
      "name": "Quaregna Cerreto",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "revo": {
    "0753e719": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "skipSearch": false
    }],
    "d18302a6": [{
      "hkey": "c6714226",
      "slug": "tregiovo",
      "name": "Tregiovo",
      "primary": true,
      "skipSearch": false
    }],
    "revo": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "riva-valdobbia": {
    "197308ac": [{
      "hkey": "4f287dcf",
      "slug": "sant-antonio",
      "name": "Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "3cbb9bc3": [{
      "hkey": "4d9cbaa6",
      "slug": "isolello",
      "name": "Isolello",
      "primary": true,
      "skipSearch": false
    }],
    "508c31d2": [{
      "hkey": "a4b90da9",
      "slug": "buzzo",
      "name": "Buzzo",
      "primary": true,
      "skipSearch": false
    }],
    "517b954a": [{
      "hkey": "68601c61",
      "slug": "balma",
      "name": "Balma",
      "primary": true,
      "skipSearch": false
    }],
    "591617de": [{
      "hkey": "f74e5d35",
      "slug": "selveglio",
      "name": "Selveglio",
      "primary": true,
      "skipSearch": false
    }],
    "5e9af1f4": [{
      "hkey": "1590cf51",
      "slug": "gabbio",
      "name": "Gabbio",
      "primary": true,
      "skipSearch": false
    }],
    "67e20ed8": [{
      "hkey": "7c9b60b9",
      "slug": "boccorio",
      "name": "Boccorio",
      "primary": true,
      "skipSearch": false
    }],
    "7937c971": [{
      "hkey": "6195bfd6",
      "slug": "vogna-di-la",
      "name": "Vogna di Là",
      "primary": true,
      "skipSearch": false
    }],
    "81243326": [{
      "hkey": "1ac0c5f4",
      "slug": "casa-verno",
      "name": "Casa Verno",
      "primary": true,
      "skipSearch": false
    }],
    "841afa08": [{
      "hkey": "e25dce17",
      "slug": "casa-piacentino",
      "name": "Casa Piacentino",
      "primary": true,
      "skipSearch": false
    }],
    "885948b4": [{
      "hkey": "5c6fad9d",
      "slug": "oro",
      "name": "Oro",
      "primary": true,
      "skipSearch": false
    }],
    "8bce7b7f": [{
      "hkey": "63cdeb61",
      "slug": "rabernardo",
      "name": "Rabernardo",
      "primary": true,
      "skipSearch": false
    }],
    "b4f0d98a": [{
      "hkey": "02071d80",
      "slug": "piane",
      "name": "Piane",
      "primary": true,
      "skipSearch": false
    }],
    "bbdf24a2": [{
      "hkey": "cf749021",
      "slug": "casa-janzo",
      "name": "Casa Janzo",
      "primary": true,
      "skipSearch": false
    }],
    "bbfbb4fd": [{
      "hkey": "de9b7abd",
      "slug": "alagna-valsesia",
      "name": "Alagna Valsesia",
      "primary": true,
      "skipSearch": false
    }],
    "bccd6002": [{
      "hkey": "14ad3b8a",
      "slug": "casa-morca",
      "name": "Casa Morca",
      "primary": true,
      "skipSearch": false
    }],
    "bcf1f401": [{
      "hkey": "c6cd8783",
      "slug": "casa-vescovo",
      "name": "Casa Vescovo",
      "primary": true,
      "skipSearch": false
    }],
    "c1ddca53": [{
      "hkey": "3f27d42c",
      "slug": "piana-fuseria",
      "name": "Piana Fuseria",
      "primary": true,
      "skipSearch": false
    }],
    "e8d5c248": [{
      "hkey": "939f1bdd",
      "slug": "vogna-sotto",
      "name": "Vogna Sotto",
      "primary": true,
      "skipSearch": false
    }],
    "riva-valdobbia": [{
      "hkey": "de9b7abd",
      "slug": "alagna-valsesia",
      "name": "Alagna Valsesia",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "ro": {
    "00a30c4b": [{
      "hkey": "59516949",
      "slug": "guarda",
      "name": "Guarda",
      "primary": true,
      "skipSearch": false
    }],
    "0d00b964": [{
      "hkey": "061a0dd6",
      "slug": "ruina",
      "name": "Ruina",
      "primary": true,
      "skipSearch": false
    }],
    "6ef2a890": [{
      "hkey": "dcf216ae",
      "slug": "riva-del-po",
      "name": "Riva del Po",
      "primary": true,
      "skipSearch": false
    }],
    "99600b6b": [{
      "hkey": "7fbd8700",
      "slug": "alberone",
      "name": "Alberone",
      "primary": true,
      "skipSearch": false
    }],
    "9cc76fd0": [{
      "hkey": "65954556",
      "slug": "zocca",
      "name": "Zocca",
      "primary": true,
      "skipSearch": false
    }],
    "ro": [{
      "hkey": "dcf216ae",
      "slug": "riva-del-po",
      "name": "Riva del Po",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "romallo": {
    "a9c13b6c": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "skipSearch": false
    }],
    "romallo": [{
      "hkey": "fee56406",
      "slug": "novella",
      "name": "Novella",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "rossano": {
    "5d7865f6": [{
      "hkey": "c6da65a6",
      "slug": "rossano-scalo",
      "name": "Rossano Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "c27d7bcf": [{
      "hkey": "80e583a5",
      "slug": "corigliano-rossano",
      "name": "Corigliano-Rossano",
      "primary": true,
      "skipSearch": false
    }],
    "rossano": [{
      "hkey": "80e583a5",
      "slug": "corigliano-rossano",
      "name": "Corigliano-Rossano",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "ruino": {
    "1e352683": [{
      "hkey": "29bcd691",
      "slug": "casa-vannone",
      "name": "Casa Vannone",
      "primary": true,
      "skipSearch": false
    }],
    "1e48f206": [{
      "hkey": "efbcd604",
      "slug": "torre-degli-alberi",
      "name": "Torre degli Alberi",
      "primary": true,
      "skipSearch": false
    }],
    "4801f324": [{
      "hkey": "e39850c0",
      "slug": "canavera",
      "name": "Canavera",
      "primary": true,
      "skipSearch": false
    }],
    "73227b31": [{
      "hkey": "fa2ac0ca",
      "slug": "pometo",
      "name": "Pometo",
      "primary": true,
      "skipSearch": false
    }],
    "8f57a011": [{
      "hkey": "d708186a",
      "slug": "colli-verdi",
      "name": "Colli Verdi",
      "primary": true,
      "skipSearch": false
    }],
    "f8a7e681": [{
      "hkey": "71fd19ae",
      "slug": "carmine",
      "name": "Carmine",
      "primary": true,
      "skipSearch": false
    }],
    "ruino": [{
      "hkey": "d708186a",
      "slug": "colli-verdi",
      "name": "Colli Verdi",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "salorno": {
    "03273a9d": [{
      "hkey": "0663a496",
      "slug": "cauria",
      "name": "Cauria",
      "primary": true,
      "skipSearch": false
    }],
    "451e8c66": [{
      "hkey": "2568c765",
      "slug": "pochi",
      "name": "Pochi",
      "primary": true,
      "skipSearch": false
    }],
    "e3b96687": [{
      "hkey": "15b983ad",
      "slug": "salorno-sulla-strada-del-vino",
      "name": "Salorno sulla strada del vino",
      "primary": true,
      "skipSearch": false
    }],
    "salorno": [{
      "hkey": "15b983ad",
      "slug": "salorno-sulla-strada-del-vino",
      "name": "Salorno sulla strada del vino",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "san-giorgio-di-mantova": {
    "1d84e21e": [{
      "hkey": "67a4e22e",
      "slug": "ghisiolo",
      "name": "Ghisiolo",
      "primary": true,
      "skipSearch": false
    }],
    "23166db0": [{
      "hkey": "636837c0",
      "slug": "san-giorgio-bigarello",
      "name": "San Giorgio Bigarello",
      "primary": true,
      "skipSearch": false
    }],
    "517cca32": [{
      "hkey": "04f0853b",
      "slug": "villanova-maiardina",
      "name": "Villanova Maiardina",
      "primary": true,
      "skipSearch": false
    }],
    "68e6e016": [{
      "hkey": "41f481af",
      "slug": "tripoli",
      "name": "Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "6d4a869e": [{
      "hkey": "10ded6f8",
      "slug": "caselle",
      "name": "Caselle",
      "primary": true,
      "skipSearch": false
    }],
    "9900e312": [{
      "hkey": "d305ef95",
      "slug": "villanova-de-bellis",
      "name": "Villanova De Bellis",
      "primary": true,
      "skipSearch": false
    }],
    "f9a555d1": [{
      "hkey": "58b5950c",
      "slug": "mottella",
      "name": "Mottella",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio-di-mantova": [{
      "hkey": "636837c0",
      "slug": "san-giorgio-bigarello",
      "name": "San Giorgio Bigarello",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "san-nazario": {
    "dd1152db": [{
      "hkey": "7a6b99be",
      "slug": "carpane",
      "name": "Carpané",
      "primary": true,
      "skipSearch": false
    }],
    "ec0bffd3": [{
      "hkey": "905eab83",
      "slug": "valbrenta",
      "name": "Valbrenta",
      "primary": true,
      "skipSearch": false
    }],
    "san-nazario": [{
      "hkey": "905eab83",
      "slug": "valbrenta",
      "name": "Valbrenta",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "sassocorvaro": {
    "1b01dcd6": [{
      "hkey": "07bd7d9e",
      "slug": "bronzo",
      "name": "Bronzo",
      "primary": true,
      "skipSearch": false
    }],
    "21ac854d": [{
      "hkey": "6db14d5b",
      "slug": "san-donato-in-taviglione",
      "name": "San Donato in Taviglione",
      "primary": true,
      "skipSearch": false
    }],
    "49448a7e": [{
      "hkey": "e1349584",
      "slug": "case-nuove",
      "name": "Case Nuove",
      "primary": true,
      "skipSearch": false
    }],
    "55b7c732": [{
      "hkey": "73f3c7ff",
      "slug": "piagniano",
      "name": "Piagniano",
      "primary": true,
      "skipSearch": false
    }],
    "64041fdd": [{
      "hkey": "fa471b31",
      "slug": "celletta",
      "name": "Celletta",
      "primary": true,
      "skipSearch": false
    }],
    "7e77c9a1": [{
      "hkey": "329e42cc",
      "slug": "valle-avellana",
      "name": "Valle Avellana",
      "primary": true,
      "skipSearch": false
    }],
    "8a26eb69": [{
      "hkey": "5b35c19d",
      "slug": "caprazzino",
      "name": "Caprazzino",
      "primary": true,
      "skipSearch": false
    }],
    "958eb0ef": [{
      "hkey": "2a3df7fa",
      "slug": "mercatale",
      "name": "Mercatale",
      "primary": true,
      "skipSearch": false
    }],
    "d12746bc": [{
      "hkey": "4d0e0734",
      "slug": "ca-guido",
      "name": "Ca' Guido",
      "primary": true,
      "skipSearch": false
    }],
    "d2f3ee0d": [{
      "hkey": "de6e7ed9",
      "slug": "fontanelle",
      "name": "Fontanelle",
      "primary": true,
      "skipSearch": false
    }],
    "d51192db": [{
      "hkey": "85d573f0",
      "slug": "sassocorvaro-auditore",
      "name": "Sassocorvaro Auditore",
      "primary": true,
      "skipSearch": false
    }],
    "sassocorvaro": [{
      "hkey": "85d573f0",
      "slug": "sassocorvaro-auditore",
      "name": "Sassocorvaro Auditore",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "sen-jan-di-fassa": {
    "255ec118": [{
      "hkey": "5dcfb873",
      "slug": "tamion",
      "name": "Tamion",
      "primary": true,
      "skipSearch": false
    }],
    "37d8ffc5": [{
      "hkey": "8918a329",
      "slug": "vigo-di-fassa",
      "name": "Vigo di Fassa",
      "primary": true,
      "skipSearch": false
    }],
    "4eb723b1": [{
      "hkey": "1fe4bc0b",
      "slug": "pozza-di-fassa",
      "name": "Pozza di Fassa",
      "primary": true,
      "skipSearch": false
    }],
    "6ed5eb16": [{
      "hkey": "15af9803",
      "slug": "pera",
      "name": "Pera",
      "primary": true,
      "skipSearch": false
    }],
    "7007cf3d": [{
      "hkey": "a33d6802",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "766f1b85": [{
      "hkey": "2103642b",
      "slug": "monzon",
      "name": "Monzon",
      "primary": true,
      "skipSearch": false
    }],
    "9b8c7af0": [{
      "hkey": "d91e6677",
      "slug": "pozza",
      "name": "Pozza",
      "primary": true,
      "skipSearch": false
    }],
    "a5481b35": [{
      "hkey": "4e415a9c",
      "slug": "san-giovanni-di-fassa",
      "name": "San Giovanni di Fassa",
      "primary": true,
      "skipSearch": false
    }],
    "af113cbb": [{
      "hkey": "095884d4",
      "slug": "meida",
      "name": "Meida",
      "primary": true,
      "skipSearch": false
    }],
    "sen-jan-di-fassa": [{
      "hkey": "4e415a9c",
      "slug": "san-giovanni-di-fassa",
      "name": "San Giovanni di Fassa",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "solbiate": {
    "1052a501": [{
      "hkey": "2ccb73ac",
      "slug": "solbiate-con-cagno",
      "name": "Solbiate con Cagno",
      "primary": true,
      "skipSearch": false
    }],
    "617a72bd": [{
      "hkey": "14da8e48",
      "slug": "concagno",
      "name": "Concagno",
      "primary": true,
      "skipSearch": false
    }],
    "solbiate": [{
      "hkey": "2ccb73ac",
      "slug": "solbiate-con-cagno",
      "name": "Solbiate con Cagno",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "soprana": {
    "d55b9b9b": [{
      "hkey": "bbaa8fc1",
      "slug": "valdilana",
      "name": "Valdilana",
      "primary": true,
      "skipSearch": false
    }],
    "soprana": [{
      "hkey": "bbaa8fc1",
      "slug": "valdilana",
      "name": "Valdilana",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "sorbolo": {
    "036af5e2": [{
      "hkey": "24b4fb1d",
      "slug": "casaltone",
      "name": "Casaltone",
      "primary": true,
      "skipSearch": false
    }],
    "4b108621": [{
      "hkey": "88d95123",
      "slug": "enzano",
      "name": "Enzano",
      "primary": true,
      "skipSearch": false
    }],
    "647bb145": [{
      "hkey": "7745a6d9",
      "slug": "bogolese",
      "name": "Bogolese",
      "primary": true,
      "skipSearch": false
    }],
    "8830c47e": [{
      "hkey": "4b21fe83",
      "slug": "chiozzola",
      "name": "Chiozzola",
      "primary": true,
      "skipSearch": false
    }],
    "c73bebfa": [{
      "hkey": "8bf31f78",
      "slug": "coenzo",
      "name": "Coenzo",
      "primary": true,
      "skipSearch": false
    }],
    "ce5a8ddf": [{
      "hkey": "2ca1ecd0",
      "slug": "frassinara",
      "name": "Frassinara",
      "primary": true,
      "skipSearch": false
    }],
    "df5cd063": [{
      "hkey": "1d922528",
      "slug": "sorbolo-mezzani",
      "name": "Sorbolo Mezzani",
      "primary": true,
      "skipSearch": false
    }],
    "e80052ce": [{
      "hkey": "4a240903",
      "slug": "ramoscello",
      "name": "Ramoscello",
      "primary": true,
      "skipSearch": false
    }],
    "sorbolo": [{
      "hkey": "1d922528",
      "slug": "sorbolo-mezzani",
      "name": "Sorbolo Mezzani",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "torre-de-busi": {
    "5d6b3233": [{
      "hkey": "2f5c988b",
      "slug": "san-gottardo",
      "name": "San Gottardo",
      "primary": true,
      "skipSearch": false
    }],
    "9098506a": [{
      "hkey": "24355277",
      "slug": "valcava",
      "name": "Valcava",
      "primary": true,
      "skipSearch": false
    }],
    "a2b6be3a": [{
      "hkey": "87ba57b9",
      "slug": "san-michele",
      "name": "San Michele",
      "primary": true,
      "skipSearch": false
    }],
    "c5343245": [{
      "hkey": "e911f659",
      "slug": "torre-de-busi",
      "name": "Torre de' Busi",
      "primary": true,
      "skipSearch": false
    }],
    "d664d9c7": [{
      "hkey": "0ae2b397",
      "slug": "san-marco",
      "name": "San Marco",
      "primary": true,
      "skipSearch": false
    }],
    "dddc9b66": [{
      "hkey": "de797d25",
      "slug": "sogno",
      "name": "Sogno",
      "primary": true,
      "skipSearch": false
    }],
    "f0010f6c": [{
      "hkey": "d4164ac7",
      "slug": "favirano",
      "name": "Favirano",
      "primary": true,
      "skipSearch": false
    }]
  },
  "trausella": {
    "ff2e9bc0": [{
      "hkey": "708f6cbf",
      "slug": "valchiusa",
      "name": "Valchiusa",
      "primary": true,
      "skipSearch": false
    }],
    "trausella": [{
      "hkey": "708f6cbf",
      "slug": "valchiusa",
      "name": "Valchiusa",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "tresigallo": {
    "184db37c": [{
      "hkey": "36e7f2e9",
      "slug": "final-di-rero",
      "name": "Final di Rero",
      "primary": true,
      "skipSearch": false
    }],
    "a5e7cf11": [{
      "hkey": "e9885d1d",
      "slug": "roncodiga",
      "name": "Roncodigà",
      "primary": true,
      "skipSearch": false
    }],
    "b533f965": [{
      "hkey": "53dfad57",
      "slug": "tresignana",
      "name": "Tresignana",
      "primary": true,
      "skipSearch": false
    }],
    "cb230deb": [{
      "hkey": "482d4bc4",
      "slug": "rero",
      "name": "Rero",
      "primary": true,
      "skipSearch": false
    }],
    "tresigallo": [{
      "hkey": "53dfad57",
      "slug": "tresignana",
      "name": "Tresignana",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "trichiana": {
    "bb7448d6": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "skipSearch": false
    }],
    "trichiana": [{
      "hkey": "c72a534f",
      "slug": "borgo-valbelluna",
      "name": "Borgo Valbelluna",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "trivero": {
    "18b982a8": [{
      "hkey": "bbaa8fc1",
      "slug": "valdilana",
      "name": "Valdilana",
      "primary": true,
      "skipSearch": false
    }],
    "6460aad4": [{
      "hkey": "dd9f575e",
      "slug": "ponzone",
      "name": "Ponzone",
      "primary": true,
      "skipSearch": false
    }],
    "trivero": [{
      "hkey": "bbaa8fc1",
      "slug": "valdilana",
      "name": "Valdilana",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "valle-mosso": {
    "620ec50a": [{
      "hkey": "bbaa8fc1",
      "slug": "valdilana",
      "name": "Valdilana",
      "primary": true,
      "skipSearch": false
    }],
    "valle-mosso": [{
      "hkey": "bbaa8fc1",
      "slug": "valdilana",
      "name": "Valdilana",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "valmala": {
    "7f6dfbfc": [{
      "hkey": "599e9aba",
      "slug": "busca",
      "name": "Busca",
      "primary": true,
      "skipSearch": false
    }],
    "valmala": [{
      "hkey": "599e9aba",
      "slug": "busca",
      "name": "Busca",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "valstagna": {
    "5943f280": [{
      "hkey": "905eab83",
      "slug": "valbrenta",
      "name": "Valbrenta",
      "primary": true,
      "skipSearch": false
    }],
    "valstagna": [{
      "hkey": "905eab83",
      "slug": "valbrenta",
      "name": "Valbrenta",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "varena": {
    "5dc6c441": [{
      "hkey": "e9ef1c06",
      "slug": "passo-di-lavaze",
      "name": "Passo di Lavazè",
      "primary": true,
      "skipSearch": false
    }],
    "cb428348": [{
      "hkey": "1958633d",
      "slug": "ville-di-fiemme",
      "name": "Ville di Fiemme",
      "primary": true,
      "skipSearch": false
    }],
    "varena": [{
      "hkey": "1958633d",
      "slug": "ville-di-fiemme",
      "name": "Ville di Fiemme",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "vendrogno": {
    "1bda9524": [{
      "hkey": "5629bd03",
      "slug": "mosnico",
      "name": "Mosnico",
      "primary": true,
      "skipSearch": false
    }],
    "66c96152": [{
      "hkey": "6a2b5fb6",
      "slug": "sanico",
      "name": "Sanico",
      "primary": true,
      "skipSearch": false
    }],
    "6e564370": [{
      "hkey": "f6ae8338",
      "slug": "noceno",
      "name": "Noceno",
      "primary": true,
      "skipSearch": false
    }],
    "7635c947": [{
      "hkey": "9089b14f",
      "slug": "inesio",
      "name": "Inesio",
      "primary": true,
      "skipSearch": false
    }],
    "827498fd": [{
      "hkey": "fdd00609",
      "slug": "comasira",
      "name": "Comasira",
      "primary": true,
      "skipSearch": false
    }],
    "c2e52876": [{
      "hkey": "251a0c67",
      "slug": "bellano",
      "name": "Bellano",
      "primary": true,
      "skipSearch": false
    }],
    "e8f3bc95": [{
      "hkey": "bc8b55f1",
      "slug": "mornico",
      "name": "Mornico",
      "primary": true,
      "skipSearch": false
    }],
    "vendrogno": [{
      "hkey": "251a0c67",
      "slug": "bellano",
      "name": "Bellano",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "vermezzo": {
    "21a8d9bf": [{
      "hkey": "85ebd104",
      "slug": "vermezzo-con-zelo",
      "name": "Vermezzo con Zelo",
      "primary": true,
      "skipSearch": false
    }],
    "vermezzo": [{
      "hkey": "85ebd104",
      "slug": "vermezzo-con-zelo",
      "name": "Vermezzo con Zelo",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "veruno": {
    "c1c41fe1": [{
      "hkey": "64cb0b85",
      "slug": "revislate",
      "name": "Revislate",
      "primary": true,
      "skipSearch": false
    }],
    "fe90acff": [{
      "hkey": "4065b7b3",
      "slug": "gattico-veruno",
      "name": "Gattico-Veruno",
      "primary": true,
      "skipSearch": false
    }],
    "veruno": [{
      "hkey": "4065b7b3",
      "slug": "gattico-veruno",
      "name": "Gattico-Veruno",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "vico-canavese": {
    "f8f496b1": [{
      "hkey": "708f6cbf",
      "slug": "valchiusa",
      "name": "Valchiusa",
      "primary": true,
      "skipSearch": false
    }],
    "vico-canavese": [{
      "hkey": "708f6cbf",
      "slug": "valchiusa",
      "name": "Valchiusa",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "zambana": {
    "35157ee2": [{
      "hkey": "a1afdcea",
      "slug": "terre-d-adige",
      "name": "Terre d'Adige",
      "primary": true,
      "skipSearch": false
    }],
    "zambana": [{
      "hkey": "a1afdcea",
      "slug": "terre-d-adige",
      "name": "Terre d'Adige",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  },
  "zelo-surrigone": {
    "7e5403a6": [{
      "hkey": "85ebd104",
      "slug": "vermezzo-con-zelo",
      "name": "Vermezzo con Zelo",
      "primary": true,
      "skipSearch": false
    }],
    "zelo-surrigone": [{
      "hkey": "85ebd104",
      "slug": "vermezzo-con-zelo",
      "name": "Vermezzo con Zelo",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;